import { addLoadingState, setVisibility } from '../helpers';

window.Contact = undefined;

export  function initContactPage(){
    const submitBtn = document.getElementById("submit-contact-form");
    submitBtn.addEventListener("click", addLoadingState);
    
    if (window.Contact && window.Contact.uploadAvailableForCategory){
        const selectBox = document.getElementById("select-box-category");
        const uploadControls = document.querySelectorAll("div[name='Data.Uploads']");

        // in Contact screen, we have only 1 control. pick the first
        const uploadControl = uploadControls[0];
        setVisibility(uploadControl);
        selectBox.addEventListener("change", (e) => {
            if(selectBox.value === window.Contact.uploadAvailableForCategory){
                setVisibility(uploadControl, true);
            } else {
                setVisibility(uploadControl, false);
            }
        })
    }
}